export default __webpack_public_path__ + "static/media/year_of_position.7da13bd5.svg";